import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/services/auth/auth.service';
import { LocalStorageService } from '@core/services/local-storage/local-storage.service';
import { MenuService, NavItem } from '@core/services/menu/menu.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'Teranet-Layout',
  templateUrl: './layout.component.html',
})
export class LayoutComponent implements OnInit, AfterViewInit {
  @ViewChild('sideNav') sideNav: ElementRef;

  isUserLogin: boolean = false;
  navItems: NavItem[];
  notificationBadges: number = 0;
  userNavItems: NavItem[];

  constructor(
    public authService: AuthService,
    public localStorageService: LocalStorageService,
    public menuService: MenuService,
    public router: Router
  ) {}

  ngOnInit() {
    this.isUserLogin = this.authService.isAuthenticated();
    if (this.isUserLogin) {
      this.getData();
    }
  }

  ngAfterViewInit() {
    this.menuService.sideNav = this.sideNav;
  }

  get checkUserIsLogin(): boolean {
    return this.localStorageService.getItem('currentUser') ? true : false;
  }

  getData() {
    const getPages = this.menuService.GetPages();
    forkJoin([getPages]).subscribe(value => {
      if (value[0]) {
        let defaultNavItems = value[0] as NavItem[];
        this.userNavItems = [];
        value[0].forEach(d => {
          if (d.order != null && d.order != undefined && d.order < 0) {
            this.userNavItems.push(d);
            let index = defaultNavItems.findIndex(x => x.displayName == d.displayName);
            if (index > -1) {
              defaultNavItems.splice(index, 1);
            }
          }
        });
        this.navItems = defaultNavItems;
        this.navItems.splice(0, 0, {
          displayName: 'Home',
          iconName: '',
          route: 'dashboard',
          order: 0,
        });
      }
    });
  }
}
